import React from "react";

export default function InputFacebook({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.productname && "is-invalid"}`}
      type="text"
      placeholder="https://facebook.com/usuario"
      name="facebook_url"
      {...register("facebook_url", {
        pattern: {
          value: /^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9._-]+\/?$/,
          message:
            "La URL debe comenzar con https://facebook.com/ y contener un usuario",
        },
      })}
    />
  );
}
